import { render, staticRenderFns } from "./RegisterFormCompany.vue?vue&type=template&id=de445f32&scoped=true"
import script from "./RegisterFormCompany.vue?vue&type=script&lang=js"
export * from "./RegisterFormCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de445f32",
  null
  
)

export default component.exports